<template>
  <van-overlay show class-name="z-50" z-index="3000">
    <div class="wrapper">
      <van-loading vertical>{{ text }}</van-loading>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    text: {
      type: String,
      default: '加载中。。。'
    }
  }
}
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
